import type { MenuItemType } from '#base/core/types/MenuItemType';

export default (): MenuItemType[] => {
	const items: MenuItemType[] = [];

	items.push({
		to: {
			url: 'https://werkhier.com',
			title: 'Fit Hier vacatures',
			newTab: true,
		},
		text: 'Werken bij Fit Hier',
		counter: countVacancies('fit'),
	});

	items.push({
		to: {
			url: '/small-group-training',
			title: 'Sporten in kleine groepen',
		},
		text: 'Small Group Training',
	});

	items.push({
		text: 'Inloggen',
		to: {
			title: 'Inloggen sport',
			url: 'https://fysio-hier.trainin.app/',
			newTab: true,
		},
	});

	items.push({
		to: {
			url: '/algemene-voorwaarden',
			title: 'Fit Hier algemene voorwaarden',
		},
		text: 'Algemene voorwaarden',
	});

	items.push({
		to: {
			url: '/privacy-beleid',
			title: 'Fit Hier privacy beleid',
		},
		text: 'Privacy beleid',
	});

	items.push({
		to: {
			url: '/cookie-instellingen',
			title: 'Cookie instellingen',
		},
		text: 'Cookie instellingen',
	});

	items.push({
		to: {
			url: '/huisregels',
			title: 'Fit Hier huisregels',
		},
		text: 'Huisregels',
	});

	items.push({
		to: {
			url: 'https://fysiohier.com',
			title: 'Fysio Hier fysiotherapie',
			newTab: true,
		},
		text: 'Fysio Hier',
	});

	return items;
};
